/* eslint-disable @typescript-eslint/no-explicit-any */
import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'
import { type ComponentCard } from './__generated/sdk'
import { type FAQItem } from '@components/faq/faq-collapsible'

// Extended to include custom sizes, etc, from tailwind.config.js
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-h1',
        'text-h2',
        'text-h3',
        'text-h4',
        'text-h5',
        'text-h6',
        'text-h7',
        'text-h8',
        'text-body1',
        'text-body2',
        'text-body3',
        'text-body4',
        'text-sub-title',
        'text-field',
        'text-ctaLarge',
        'text-ctaSmall',
      ],
      aspect: ['blog-post'],
      'bg-image': ['astronaut-gradient'],
      animate: ['accordion-down', 'accordion-up'],
    },
  },
})
export const cn = (...inputs: ClassValue[]) => customTwMerge(clsx(inputs))

/**
 * This function takes an object and reduces it to a form body string for POST requests
 * @param data
 * @returns
 */
export const reduceObjectToFormBody = (data: Record<string, any>) => {
  let formBody = ''
  for (const [key, value] of Object.entries(data)) {
    formBody += `&${key}=${encodeURIComponent(value ?? '')}`
  }
  // remove the first character '&' from the formBody
  return formBody.slice(1)
}

export const faqItemsFromComponentCards = (items: ComponentCard[]): FAQItem[] =>
  items.map((i) => ({
    title: i?.title ?? '',
    description: i?.subtitle ?? '',
  })) ?? []
